import React from 'react'
import './invite-teachers-v2.scss'
import SessionCache from '../../routes/session-cache'
import { Modal, ModalBody } from 'reactstrap'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import CommonUtils from '../../../utility/common-utilities'
import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown'
import CommonApi from '../../../apis/common'

class InviteTeachersV2 extends React.Component {
  state = {
    mobileNumber: '',
    email: '',
    isWhatsappInvited: false,
    countryCodeDropdown: []
  }

  constructor (props) {
    super(props)
    let user = SessionCache.getUser()
    this.user = user
    this.state.teachers = [
      { mobileNumber: user.mobileNumber, countryCode: user.countryCode }
    ]
    this.state.type = this.props.type || 'teacher'

    this.getCountryCodes()
  }

  getCountryCodes (payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropdown = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropdown })
        }
      })
      .catch(err => {})
  }

  buildCountryCodeDropdown (list = []) {
    let countryCodeDropdown = []
    let countryCodeHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!countryCodeHash[item.dialCode]) {
        countryCodeHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.name} ${item.dialCode}`,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: countryCodeHash })
    return countryCodeDropdown
  }

  onCountryCodeSearch (value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  onSelectCountryCode (option, index) {
    const { teachers } = this.state
    const countryCode = option?.value

    teachers[index].countryCode = countryCode
    this.setState({ teachers })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  copyLink = _ => {
    const user = SessionCache.getUser()
    const dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)
    dummy.value = `Hello,

    You are requested to join Countingwell School's account on the Countingwell Maths Homework Portal by logging in to this link: https://countingwell.com/school/users/signup?user=${user.id}&type=${this.state.type}
    
    Once you join, your registration will get approved and after that, you may start assigning homework, assignments and other tasks related to Maths to your students from the Countingwell platform.
    
    You can also join Countingwell's exclusive telegram group Maths Gurus for more worksheets, videos and other content through this link: https://t.me/+3XO7EeE3-M4zZjU1
    
    Thank you.`
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  onChangeMobile = (event, key, index) => {
    const { teachers } = this.state
    const mobileNumber = event.target.value

    teachers[index].mobileNumber = mobileNumber
    this.setState({ teachers })
  }

  validateAllMobileNumbers = () => {
    const { teachers } = this.state
    let isValid = true
    for (let i = 0; i < teachers.length; i++) {
      const teacher = teachers[i]
      const mobileNumber = teacher.mobileNumber
      const countryCode = teacher.countryCode
      const countryCodeDetail = this.state.hashedCountryCode[countryCode]
      const validateCountryCode = CommonUtils.validateMobileNumber(
        mobileNumber,
        countryCodeDetail
      )
      if (!validateCountryCode) {
        teacher.isInvalidMobile = true
        teachers[i] = teacher
        this.setState({ teachers })
        isValid = false
      } else {
        teacher.isInvalidMobile = false
        teachers[i] = teacher
        this.setState({ teachers })
      }
      if (i === teachers.length - 1) return isValid
    }
  }

  allowEdit = key => {
    this.setState({
      ['allow' + key]: true,
      ['disable' + key]: true
    })
  }

  onContinue = _ => {
    this.props.onContinue()
  }

  sendInvitation = _ => {
    const { teachers, type } = this.state
    const isValid = this.validateAllMobileNumbers()
    if (!isValid) return

    let payload = {
      teachers,
      schoolCode: this.user.schoolInfo.schoolCode,
      adminName: this.user.name,
      schoolName: this.user.schoolInfo?.name,
      type
    }
    this.setState({
      isInviteSubmit: true
    })
    SchoolApi.sendTeacherInvitations(payload)
      .then(response => {
        this.setState({
          isInviteSubmit: false,
          teachers: [
            {
              mobileNumber: this.user.mobileNumber,
              countryCode: this.user.countryCode
            }
          ]
        })
        // this.props.onClose(true)
        this.showToaster('info', 'Message shared successfully on Whatsapp')
      })
      .catch(err => {
        this.showToaster('error', 'Something went wrong')
        this.setState({
          isInviteSubmit: false
        })
      })
  }

  removeTeacher = index => {
    const { teachers } = this.state
    teachers.splice(index, 1)
    this.setState({
      teachers
    })
  }

  addNewTeacher = _ => {
    const { teachers } = this.state
    teachers.push({ mobileNumber: '', countryCode: '+91' })
    this.setState({
      teachers
    })
  }

  render () {
    const {
      toasterMessage,
      toasterType,
      mobileNumber,
      isInviteSubmit,
      showToaster,
      countryCodeDropdown,
      countryCode,
      isInvalidMobile,
      teachers,
      type
    } = this.state
    return (
      <Modal
        className='cw-custom-modal custom-toaster-modal invite-teachers-v2'
        isOpen={true}
        toggle={this.props.onClose}
        size={'lg'}
      >
        <ModalBody>
          <div className=''>
            <div className='pt-2 pb-4'>
              <span className='text-right'>
                <img
                  className='close-icon cursor-pointer'
                  src={getImageSource(ImageConstants.CROSS)}
                  onClick={this.props.onClose}
                />
              </span>
            </div>
            <div>
              <div className='invite-teachers-container'>
                <div className='row'>
                  <div className='col'>
                    <div className='text-center'>
                      <strong className='header-text'>
                        SHARE THE INVITE WITH {type === "teacher" ? "TEACHERS" : "USERS"}
                      </strong>
                      <div className='header-description'>
                        and ask them to follow the on-screen instructions to
                        create their own accounts and join the countingwell
                        platform.
                      </div>
                    </div>
                    <div className='separator'>
                      <img src={getImageSource(ImageConstants.SEPARATOR)} />
                    </div>
                    <div className='share-container mt-2 my-2'>
                      <div className='share-left'>
                        <div className='step'>1</div>
                      </div>
                      <div className='share-right'>
                        <div className='title'>COPY & SHARE</div>
                        <div className='description'>
                          Copy the link below and paste it in an email or
                          WhatsApp and share with other {type === "teacher" ? "teachers": "users"}.
                        </div>
                      </div>
                    </div>
                    <div className='copy-container'>
                      <div className='share-link'>
                        https://countingwell.com/school/users/signup?user={this.user.id}&type={this.state.type}
                      </div>
                      <div
                        className='copy-button cursor-pointer'
                        onClick={this.copyLink}
                      >
                        <img src={getImageSource(ImageConstants.CLONE_WHITE)} />{' '}
                        <span>COPY</span>
                      </div>
                    </div>
                    <div className='separator'>
                      <img src={getImageSource(ImageConstants.SEPARATOR)} />
                      <span className='separator-text'>OR</span>
                    </div>
                    <div className='share-container mt-2 my-2'>
                      <div className='share-left'>
                        <div className='step'>2</div>
                      </div>
                      <div className='share-right'>
                        <div className='title'>INSTANT SHARE ON WHATSAPP</div>
                        <div className='description'>
                          Enter a WhatsApp number of the person you want to
                          share the link with. Or send to yourself by entering
                          your number and forward it to other {type === "teacher" ? "teachers" : "users"} from your
                          own WhatsApp number.
                        </div>
                      </div>
                    </div>

                    {teachers.map((teacher, index) => (
                      <>
                        <div className='input-container' key={index}>
                          <div
                            className={`input-box d-inline-block  ${
                              teacher.isInvalidMobile && teacher.mobileNumber
                                ? 'invalid'
                                : ''
                            }`}
                          >
                            {countryCodeDropdown?.length && (
                              <div className='cw-country-code d-inline-block'>
                                <Dropdown
                                  key='countryCode'
                                  placeholder='Search country code'
                                  options={countryCodeDropdown}
                                  onSelect={option =>
                                    this.onSelectCountryCode(option, index)
                                  }
                                  text='title'
                                  onSearch={value =>
                                    this.onCountryCodeSearch(value)
                                  }
                                  style={{ background: '#F6F7F5' }}
                                  value={teacher.countryCode}
                                />
                              </div>
                            )}
                            <span className='cw-separator'></span>
                            <input
                              className={`cw-mobile-number cw-input-left`} //${!allowmobileNumber&& 'not-editable'}
                              placeholder='Enter Mobile Number'
                              value={teacher.mobileNumber}
                              onChange={e =>
                                this.onChangeMobile(e, 'mobileNumber', index)
                              }
                            />
                          </div>
                          <div className='delete-container'>
                            <img
                              className='close-icon cursor-pointer'
                              onClick={_ => this.removeTeacher(index)}
                              src={getImageSource(ImageConstants.DELETE_RED)}
                            />
                          </div>
                        </div>
                        <div className='col'>
                          {teacher.isInvalidMobile && (
                            <span className='invalid-text'>
                              Enter valid phone number
                            </span>
                          )}
                        </div>
                      </>
                    ))}
                    <div className='add-teacher text-right'>
                      <span
                        className='cursor-pointer'
                        onClick={this.addNewTeacher}
                      >
                        + ADD WHATSAPP NO
                      </span>
                    </div>
                    <div className='mt-2 text-center'>
                      {!isInviteSubmit && (
                        <button
                          className={
                            !isInviteSubmit
                              ? 'cw-button-primary cw-button-mod'
                              : 'cw-button-disabled'
                          }
                          onClick={() =>
                            !isInviteSubmit && this.sendInvitation()
                          }
                        >
                          <img
                            src={getImageSource(ImageConstants.WHATSAPP_WHITE)}
                          />{' '}
                          <span>SHARE</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {showToaster ? (
                <ToasterComponent
                  message={toasterMessage}
                  type={toasterType}
                  position='bottom-center'
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default InviteTeachersV2
